import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { doc, Firestore, getDoc } from '@fido/firebase/firestore';
import { CanActivateFn, Router } from '@angular/router';
import { ORGANIZATIONS } from 'fido-types';
import { firstValueFrom } from 'rxjs';
import { organizationConverter } from '../data/organization.converter';

export const teamsEnabledGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const firestore = inject(Firestore);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (!u) return router.createUrlTree(['/sign-in']);

  const appUser = await getDoc(doc(firestore, 'users', u.uid));
  // Missing user doc: transient sync race or deleted doc — punt to onboarding
  // rather than throwing an uncaught navigation error.
  if (!appUser.exists()) return router.createUrlTree(['/onboarding']);
  const organizationId = appUser.data()['organizationId'];
  if (!organizationId) return router.createUrlTree(['/onboarding']);

  const orgDoc = await getDoc(
    doc(firestore, ORGANIZATIONS, organizationId).withConverter(organizationConverter),
  );
  // Missing org doc: organizationId points at nothing (deleted org). Send
  // home; the home page surfaces the bad state safely.
  if (!orgDoc.exists()) return router.createUrlTree(['/']);
  const orgData = orgDoc.data();
  if (!orgData?.settings?.teamsEnabled) {
    return router.createUrlTree(['/']);
  }
  return true;
};
